<template>
  <div :class="{ animate: isActive }">
    <div class="slide-proportion-3-2">
      <div class="right-block-positioner positioner">
        <div class="number-4">
          <div class="number-4__proportion">
            <img
              src="~/../../../../assets/img/minus4.svg"
              alt="img"
              class="inside-asset"
            />
          </div>
        </div>
        <div class="layer-wrapper">
          <circle-wrapper visible-overflow>
            <img
              src="~/../../../../assets/img/01.png"
              alt="img"
              class="circle-bg-img"
            />
            <div class="target">
              <img
                src="~/../../../../assets/img/pistolet.png"
                alt="img"
                class="target-img"
              />
              <img
                src="~/../../../../assets/img/half_circle_layer_3.svg"
                class="overflow-img"
              />
            </div>
            <div class="shadow">
              <img
                src="~/../../../../assets/img/shadow.png"
                class="inside-asset"
              />
            </div>
          </circle-wrapper>
        </div>
        <a
          type="button"
          class="custom-btn"
          @click="$emit('pause', true)"
          @mouseover="$emit('pause', true)"
          @mouseout="$emit('start-next', true)"
          target="_blank"
          href="https://www.okko.ua/fuel-map?filter%5Bgas_stations,fuel_type%5D=256"
        >
          ДЕ ЗАПРАВИТИ?
        </a>
      </div>
    </div>
  </div>
</template>

<script>
  import CircleWrapper from '../../slideComponents/CircleWrapper.vue';

  export default {
    components: {
      CircleWrapper
    },
    props: {
      isActive: {
        type: Boolean,
        default: false,
        required: false
      }
    }
  };
</script>

<style lang="scss" scoped>
  @import '~styles/scss/slide-fragment.scss';
  .number-4 {
    position: absolute;
    top: 6px;
    left: 0;
    width: 39%;
    &__proportion {
      position: absolute;
      width: 100%;
      height: 0;
      padding-bottom: 145%;
    }
    pointer-events: none;
    @include respond-to(tabletRotate) {
      position: relative;
      display: inline-block;
      vertical-align: bottom;
      margin-top: 6px;
      height: auto;
      &__proportion {
        position: relative;
      }
    }
  }
  .layer-wrapper {
    position: absolute;
    right: 2%;
    top: 0;
    width: 57.6%;
    height: 0;
    @include respond-to(tabletRotate) {
      display: inline-block;
      vertical-align: bottom;
      position: relative;
      height: auto;
      right: 0;
    }
  }

  .positioner {
    @media screen and (min-width: $tabletRotate) and (max-width: 1150px) {
      margin-left: 10%;
      width: 90%;
    }
  }

  .circle-bg-img {
    position: absolute;
    top: 1%;
    left: 1%;
    width: 98%;
    height: 98%;
    object-fit: cover;
  }

  .target {
    position: absolute;
    bottom: 3%;
    right: 30%;
    width: 102%;
    height: 100%;
    z-index: 1;
    overflow: hidden;
    &-img {
      position: absolute;
      width: 100%;
      top: 2%;
    }
    .overflow-img {
      position: absolute;
      width: 88.4%;
      top: 69%;
      left: 40.2%;
    }
  }

  .shadow {
    position: absolute;
    top: 40.8%;
    left: -45%;
    width: 90%;
    height: 87%;
    z-index: 1;
  }

  .custom-btn {
    display: none;

    @include respond-to(tabletRotate) {
      display: block;
      margin-top: 84px;
      z-index: 3;
      width: 50%;
    }
    @media screen and (max-height: $mm-h) {
      margin-top: 61px;
    }
    @media screen and (max-height: $r-h) {
      margin-top: 46px;
    }
    @media screen and (max-height: $m-h) {
      margin-top: 44px;
      font-size: 11px;
      line-height: 13px;
      padding: 15px;
    }
    @media screen and (max-height: $sm-h) {
      margin-top: 35px;
    }
    @include respond-to(mobileRotate) {
      font-size: 11px;
      line-height: 13px;
      padding: 15px;
    }
  }

  .animate {
    .target-img {
      animation: target-animation 2s 0.8s ease-in-out backwards;
    }
    .shadow {
      animation: shadow-animation 1.5s 1.3s ease-in-out backwards;
    }
  }
  @keyframes shadow-animation {
    from {
      opacity: 0;
      transform: translateY(-6%) translateX(-2.6%) rotate(3deg);
    }
    to {
      opacity: 1;
    }
  }
  @keyframes target-animation {
    from {
      transform-origin: right bottom;
      transform: scale(0) translateY(10%);
    }
    to {
      transform-origin: right bottom;
      transform: none;
    }
  }

  @media screen and (max-height: 930px) and (min-width: 1260px) and (max-width: 1920px) and (max-height: 41.1vw) {
    .positioner {
      width: 80%;
      margin-left: 20%;
      margin-top: 0;
    }
  }
  @media screen and (min-height: 676px) and (min-width: 1286px) and (max-height: 760px) and (max-width: 1440px) {
    .positioner {
      width: 80%;
      margin-left: 20%;
      margin-top: 0;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/SlideFragment/Slides/Fact1/Right.vue